@if (profileLoaded && profile !== null) {
  <div id="header-user-menu-id" #headerUserMenu class="header-user-menu"
    [ngClass]="(isImpersonated | async) ? 'impersonated': ''"
    (click)="openCloseUserMenu()">
    @if (!(isImpersonated | async)) {
      <div class="identicon">
        <aa-avatar-icon [src]="profile.identiconDataUrl" [alt]="profile.firstLastName" [size]="'48px'"
          [withBg]="false">
        </aa-avatar-icon>
      </div>
      <div class="header-user-infos">
        <span class="firstLastName">{{ profile.firstLastName }}</span><br />
        <div class="profile-title">
          {{ profile.title }}
        </div>
        <i class="fas angle-user-menu" [ngClass]="{ 'fa-angle-down': !menuOpened, 'fa-angle-up': menuOpened }"
        aria-hidden="true"></i>
      </div>
    } @else {
      <div class="identicon">
        <aa-avatar-icon [src]="profile.identiconDataUrl" [alt]="profile.firstLastName" [size]="'48px'"
          [withBg]="false">
        </aa-avatar-icon>
      </div>
      <div class="header-user-infos">
        <span class="firstLastName">{{ profile.firstLastName }}</span>
        <br />
        <div class="profile-title">
          {{ impersonation.email }}<br />({{impersonation.entityShortId}})
        </div>
      </div>
    }
  </div>
}
@if (!profileLoaded) {
  <div class="aa-color-primary-normal aa-medium-current-text">
    <div class="avatar">
      <aa-avatar-icon [src]="'./assets/images/AurorA.png'" [alt]="'AurorA'" [size]="'48px'"></aa-avatar-icon>
    </div>
  </div>
}
